import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import messages from '../messages';
import Global from '../../../store/global-selectors';
import { emptyObject } from 'ui-components/default-props/empty';

const name = <FormattedMessage {...messages.dimensionsColumnHeader} />;

const DimensionColumn = ({ data = emptyObject }) => {
  const { length, width, height, dimensionUnitOfMeasureId: unit } = data;
  const usersPreferredUnit = useSelector(Global.selectSellerDefaultDimensionUnit);
  const unitOfMeasure = unit === 'Unknown' ? usersPreferredUnit : unit;
  const dimensionStr = useMemo(() => {
    const arr = [];
    if (length === 0 && width === 0 && height === 0) {
      return '';
    }
    if (length === 0 || length) {
      arr.push(length);
    }
    if (width === 0 || width) {
      arr.push(width);
    }
    if (height === 0 || height) {
      arr.push(height);
    }
    return arr.join(' x ');
  }, [length, width, height]);
  if (dimensionStr) {
    return `${dimensionStr} ${unitOfMeasure}`;
  }
  return '';
};

DimensionColumn.propTypes = {
  data: PropTypes.shape({
    length: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    dimensionUnitOfMeasureId: PropTypes.string,
  }),
};

export default {
  getMessageDescriptor: () => messages.dimensionsColumnHeader,
  name,
  render: (data) => <DimensionColumn data={data} />,
};
